export const logEvent = function(event){
  if (!event.type)
    throw new Error('type is required.')

  fetch(import.meta.env.VITE_API_URL + '/api/v1/event', {
    method: 'post',
    body: JSON.stringify(event),
    headers: {
      'Content-Type': 'application/json',
    },
  })
}



export const logContentBlockPressEvent = function(contentBlockId){
  const urlParams = new URLSearchParams(window.location.search);
  // Get the values of 'userId' and 'pageId' from the query parameters
  const userId = urlParams.get("userId");
  const pageId = urlParams.get("pageId");

  
  logEvent({
    type: 'page/content-block-press',
    userId,
    pageId,
    contentBlockId,
  })

}